import script from "./ContactTypePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactTypePicker.vue?vue&type=script&lang=ts&setup=true"

import "./ContactTypePicker.vue?vue&type=style&index=0&id=1de2bf0a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1de2bf0a"]])

export default __exports__